module.exports = __webpack_public_path__ + "media/images/home/rain_chart-04db9d5de11a78031d2b4cfb18748a5b.png";